import React from 'react'
import {
  LayoutDashboard,
  Phone,
  Users,
  Hash,
  GitFork,
  BarChart3,
  UsersRound,
  DollarSign,
  BookOpen,
  Bot,
  FileSpreadsheet,
  List,
  HandMetal,
  Router,
  Map,
  MessageCircle,
  MessageSquare,
  Mail,
  Train,
  RotateCw,
  Paperclip,
  Play,
  Type,
  Unlock,
  Contact,
  Activity,
  HardDrive,
  PhoneOutgoing,
  FolderOpen,
  Globe,
} from 'lucide-react'

const dashboard = {
  name: 'Dashboard',
  to: '/dashboard',
  icon: <LayoutDashboard className="w-5 h-5" />,
  badge: 'NEW'
}

const calls = {
  name: 'Calls',
  to: '/resources/calls',
  icon: <Phone className="w-5 h-5" />,
  items: [
    {
      name: 'Calls',
      to: '/resources/calls/calls_list',
    },
    {
      name: 'Groupcalls',
      to: '/resources/groupcalls/groupcalls_list',
    },
  ]
};

const customers = {
  name: 'Customers',
  icon: <Users className="w-5 h-5" />,
  items: [
    {
      name: 'Customers',
      to: '/resources/customers/customers_list',
    },
  ]
};

const customer = {
  name: 'Customer',
  icon: <Users className="w-5 h-5" />,
  items: [
    {
      name: 'Customer',
      to: '/resources/customer/customer_detail',
    },
  ]
};

const outbound_config = {
  name: 'Outbound Config',
  icon: <PhoneOutgoing className="w-5 h-5" />,
  items: [
    {
      name: 'Outbound Config',
      to: '/resources/outbound_config/outbound_config_detail',
    },
  ]
};

const queues = {
  name: 'Queues',
  icon: <BarChart3 className="w-5 h-5" />,
  items: [
    {
      name: 'Queues',
      to: '/resources/queues/queues_list',
    },
    {
      name: 'Queuecalls',
      to: '/resources/queues/queuecalls_list',
    }
  ]
};

const contacts = {
  name: 'Contacts',
  icon: <Contact className="w-5 h-5" />,
  items: [
    {
      name: 'Contacts',
      to: '/resources/contacts/contacts_list',
    },
  ]
};

const contact_cases_unresolved = {
  name: 'Cases',
  icon: <FolderOpen className="w-5 h-5" />,
  items: [
    {
      name: 'Cases',
      to: '/resources/contacts/contact_cases_unresolved',
    },
  ]
};

const tags = {
  name: 'Tags',
  icon: <Paperclip className="w-5 h-5" />,
  items: [
    {
      name: 'Tags',
      to: '/resources/tags/tags_list',
    },
  ]
};

const storage_files = {
  name: 'Storage Files',
  icon: <HardDrive className="w-5 h-5" />,
  items: [
    {
      name: 'Storage Files',
      to: '/resources/storage_files/storage_files_list',
    },
  ]
};

const numbers = {
  name: 'Numbers',
  icon: <Hash className="w-5 h-5" />,
  items: [
    {
      name: 'Active',
      to: '/resources/numbers/active_list',
    },
    {
      name: 'Buy',
      to: '/resources/numbers/buy_list',
    }
  ]
};

const flows = {
  name: 'Flows',
  icon: <GitFork className="w-5 h-5" />,
  items: [
    {
      name: 'Flows',
      to: '/resources/flows/flows_list',
    },
    {
      name: 'Activeflows',
      to: '/resources/flows/activeflows_list',
    }
  ]
};

const agents = {
  name: 'Agents',
  icon: <UsersRound className="w-5 h-5" />,
  items: [
    {
      name: 'Agents',
      to: '/resources/agents/agents_list',
    },
  ]
};

const billings = {
  name: 'Billings',
  icon: <DollarSign className="w-5 h-5" />,
  items: [
    {
      name: 'Billing Account',
      to: '/resources/billing_accounts/billing_accounts_detail',
    },
    {
      name: 'Billings',
      to: '/resources/billings/billings_list',
    },
  ]
};

const conferences = {
  name: 'Conferences',
  icon: <BookOpen className="w-5 h-5" />,
  items: [
    {
      name: 'Conferences',
      to: '/resources/conferences/conferences_list',
    },
    {
      name: 'Conferencecalls',
      to: '/resources/conferences/conferencecalls_list',
    },
  ]
};

const ais = {
  name: 'AI',
  icon: <Bot className="w-5 h-5" />,
  items: [
    {
      name: 'Engines',
      to: '/resources/ais/ais_list',
    },
    {
      name: 'Teams',
      to: '/resources/teams/teams_list',
    },
    {
      name: 'RAGs',
      to: '/resources/rags/rags_list',
    },
    {
      name: 'MCP Servers',
      to: '/resources/mcpservers/mcpservers_list',
    },
    {
      name: 'Calls',
      to: '/resources/aicalls/aicalls_list',
    },
    {
      name: 'Summaries',
      to: '/resources/aisummaries/list',
    }
  ]
};

const conversations = {
  name: 'Conversations',
  icon: <MessageCircle className="w-5 h-5" />,
  items: [
    {
      name: 'Conversations',
      to: '/resources/conversation_conversations/list',
    },
    {
      name: 'Connections',
      to: '/resources/conversation_accounts/list',
    },  ]
};

const messages = {
  name: 'Messages',
  icon: <MessageSquare className="w-5 h-5" />,
  items: [
    {
      name: 'Messages',
      to: '/resources/messages/messages_list',
    },
  ]
};

const trunks = {
  name: 'Trunks',
  icon: <Router className="w-5 h-5" />,
  items: [
    {
      name: 'Trunks',
      to: '/resources/trunks/trunks_list',
    },
  ]
};

const extensions = {
  name: 'Extensions',
  icon: <Map className="w-5 h-5" />,
  items: [
    {
      name: 'Extensions',
      to: '/resources/extensions/extensions_list',
    },
  ]
};

const providers = {
  name: 'Providers',
  icon: <Train className="w-5 h-5" />,
  items: [
    {
      name: 'Providers',
      to: '/resources/providers/providers_list',
    },
  ]
};

const routes = {
  name: 'Routes',
  icon: <RotateCw className="w-5 h-5" />,
  items: [
    {
      name: 'Routes',
      to: '/resources/routes/routes_list',
    },
  ]
};

const recordings = {
  name: 'Recordings',
  icon: <Play className="w-5 h-5" />,
  items: [
    {
      name: 'Recordings',
      to: '/resources/recordings/recordings_list',
    },
  ]
};

const transcribes = {
  name: 'Transcribes',
  icon: <Type className="w-5 h-5" />,
  items: [
    {
      name: 'Transcribes',
      to: '/resources/transcribes/transcribes_list',
    },
  ]
};

const accesskeys = {
  name: 'Accesskeys',
  icon: <Unlock className="w-5 h-5" />,
  items: [
    {
      name: 'Accesskeys',
      to: '/resources/accesskeys/accesskeys_list',
    },
  ]
};

const emails = {
  name: 'Emails',
  icon: <Mail className="w-5 h-5" />,
  items: [
    {
      name: 'Emails',
      to: '/resources/emails/list',
    },
  ]
};

const webchat_widgets = {
  name: 'Webchat',
  icon: <Globe className="w-5 h-5" />,
  items: [
    {
      name: 'Webchat',
      to: '/resources/webchat_widgets/list',
    },
  ]
};



//// Campaign ////////////////////////////////////////////////////////////////////////////////

const campaigns = {
  name: 'Campaigns',
  to: '/resources/campaigns/campaigns_list',
  icon: <HandMetal className="w-5 h-5" />,
  items: [
    {
      name: 'Campaigns',
      to: '/resources/campaigns/campaigns_list',
    },
    {
      name: 'Campaigncalls',
      to: '/resources/campaigns/campaigncalls_list',
    },
  ]
};

const outdials = {
  name: 'Outdials',
  icon: <FileSpreadsheet className="w-5 h-5" />,
  items: [
    {
      name: 'Outdials',
      to: '/resources/outdials/outdials_list',
    },
  ]
};

const outplans = {
  name: 'Outplans',
  icon: <List className="w-5 h-5" />,
  items: [
    {
      name: 'Outplans',
      to: '/resources/outplans/outplans_list',
    },
  ]
};

// groupProject defines menu groups for project resource management.
const groupProject = [
  customers,
  providers,
  routes,
];

// groupAdmin defines menu groups for admin resource management.
const groupAdmin = [
  numbers,
  billings,
  accesskeys,
  customer,
  outbound_config,
];

// groupManager defines menu groups for normal resource management.
const groupResourceManager = [
  flows,
  agents,
  contacts,
  contact_cases_unresolved,
  queues,
  tags,
  conferences,
  ais,
  emails,
  webchat_widgets,
  recordings,
  transcribes,
  trunks,
  extensions,
  storage_files,
];

// groupCommnunication defines menu groups for communication.
const groupCommnunication = [
  calls,
  conversations,
  messages,
];

// groupCampaign defines menu groups for campaign management.
const groupCampaign = [
  campaigns,
  outdials,
  outplans,
];

// groupAgent defines menu groups for agent permission user.
const groupAgent = [
  calls,
  conferences,
  conversations,
  messages,
];

// navCustomerAdmin defines navigation menu for customer admin permission.
export const navCustomerAdmin = [
  dashboard,
  ...groupCommnunication,
  ...groupResourceManager,
  ...groupAdmin,
  ...groupCampaign,
]

// navCustomerManager defines navigation menu for customer manager permission.
export const navCustomerManager = [
  dashboard,
  ...groupCommnunication,
  ...groupResourceManager,
  ...groupCampaign,
]

// navCustomerAgent defines navigation menu for customer agent permission.
export const navCustomerAgent = [
  dashboard,
  ...groupCommnunication,
]

// navProjectAdmin defines navigation menu for project admin permission.
export const navProjectAdmin = [
  dashboard,
  ...groupCommnunication,
  ...groupResourceManager,
  ...groupAdmin,
  ...groupCampaign,
  ...groupProject,
];

// ===== NEW SECTION-BASED NAVIGATION =====

export const navSections = {
  voice: {
    id: 'voice',
    name: 'Voice',
    icon: 'Phone',
    defaultOpen: false,
    items: [
      { name: 'Dashboard', to: '/voice/dashboard' },
      { name: 'Calls', to: '/resources/calls/calls_list' },
      { name: 'Conferences', to: '/resources/conferences/conferences_list' },
      { name: 'Queues', to: '/resources/queues/queues_list' },
      { name: 'Recordings', to: '/resources/recordings/recordings_list' },
      { name: 'Transcribes', to: '/resources/transcribes/transcribes_list' },
    ]
  },
  messaging: {
    id: 'messaging',
    name: 'Messaging',
    icon: 'MessageSquare',
    defaultOpen: false,
    items: [
      { name: 'Dashboard', to: '/messaging/dashboard' },
      { name: 'SMS Messages', to: '/resources/messages/messages_list' },
      { name: 'Emails', to: '/resources/emails/list' },
      { name: 'Conversations', to: '/resources/conversation_conversations/list' },
      { name: 'Connections', to: '/resources/conversation_accounts/list' },
      { name: 'Webchat', to: '/resources/webchat_widgets/list' },
    ]
  },
  ai: {
    id: 'ai',
    name: 'AI Services',
    icon: 'Bot',
    defaultOpen: false,
    items: [
      { name: 'Dashboard', to: '/ai/dashboard' },
      { name: 'Assistants', to: '/resources/ais/ais_list' },
      { name: 'Teams', to: '/resources/teams/teams_list' },
      { name: 'RAGs', to: '/resources/rags/rags_list' },
      { name: 'MCP Servers', to: '/resources/mcpservers/mcpservers_list' },
      { name: 'AI Calls', to: '/resources/aicalls/aicalls_list' },
      { name: 'AI Summaries', to: '/resources/aisummaries/list' },
      { name: 'AI Audits', to: '/resources/aiaudits/list' },
      { name: 'AI Proposals', to: '/resources/aipromptproposals/aipromptproposals_list' },
    ]
  },
  timeline: {
    id: 'timeline',
    name: 'Timeline',
    icon: 'Activity',
    defaultOpen: false,
    items: [
      { name: 'Dashboard', to: '/timeline/dashboard' },
      { name: 'Activeflows', to: '/timeline/activeflows' },
    ]
  },
  platform: {
    id: 'platform',
    name: 'Platform',
    icon: 'Settings',
    defaultOpen: false,
    items: [
      { name: 'Dashboard', to: '/platform/dashboard' },
      { name: 'Flows', to: '/resources/flows/flows_list' },
      { name: 'Numbers', to: '/resources/numbers/active_list' },
      { name: 'Campaigns', to: '/resources/campaigns/campaigns_list' },
      { name: 'Agents', to: '/resources/agents/agents_list' },
      { name: 'Contacts', to: '/resources/contacts/contacts_list' },
      { name: 'Cases', to: '/resources/contacts/contact_cases_unresolved' },
      { name: 'Extensions', to: '/resources/extensions/extensions_list' },
      { name: 'Trunks', to: '/resources/trunks/trunks_list' },
      { name: 'Tags', to: '/resources/tags/tags_list' },
      { name: 'Storage Files', to: '/resources/storage_files/storage_files_list' },
    ]
  },
  operations: {
    id: 'operations',
    name: 'Operations',
    icon: 'BarChart3',
    defaultOpen: false,
    permission: 0x0020, // CustomerAdmin and above
    items: [
      { name: 'Dashboard', to: '/operations/dashboard' },
      { name: 'Customer Profile', to: '/resources/customer/customer_detail' },
      { name: 'Outbound Config', to: '/resources/outbound_config/outbound_config_detail' },
      { name: 'Billing Account', to: '/resources/billing_accounts/billing_accounts_detail' },
      { name: 'Billing History', to: '/resources/billings/billings_list' },
      { name: 'Access Keys', to: '/resources/accesskeys/accesskeys_list' },
    ]
  },
  platformManagement: {
    id: 'platformManagement',
    name: 'System',
    icon: 'Shield',
    defaultOpen: false,
    permission: 0x0001, // ProjectAdmin only
    items: [
      { name: 'Dashboard', to: '/platform-management/dashboard' },
      { name: 'Customers', to: '/resources/customers/customers_list' },
      { name: 'Providers', to: '/resources/providers/providers_list' },
      { name: 'Routes', to: '/resources/routes/routes_list' },
    ]
  }
}

export const getNavigationForPermission = (permission) => {
  const sections = []

  // Base sections for all authenticated users
  sections.push(navSections.voice)
  sections.push(navSections.messaging)
  sections.push(navSections.ai)
  sections.push(navSections.timeline)

  // ProjectAdmin (0x0001) - gets everything
  if (permission & 0x0001) {
    sections.push(navSections.platform)
    sections.push(navSections.operations)
    sections.push(navSections.platformManagement)
    return sections
  }

  // CustomerAdmin (0x0020) - gets operations + platform (no Platform Management)
  if (permission & 0x0020) {
    sections.push(navSections.platform)
    sections.push(navSections.operations)
    return sections
  }

  // CustomerManager (0x0040) - gets platform only
  if (permission & 0x0040) {
    sections.push(navSections.platform)
    return sections
  }

  // CustomerAgent (0x0010) - gets only base sections (voice, messaging, ai)
  return sections
}
